import { deepFreeze } from "./util/misc.js";

const COLORS = {
  admin: {
    dark: true,
    fg: "grey-1",
    bg: "admin",
  },

  primary: {
    dark: true,
    fg: "grey-1",
    bg: "primary",
  },
  secondary: {
    dark: true,
    fg: "grey-1",
    bg: "secondary",
  },
  accent: {
    dark: true,
    fg: "grey-1",
    bg: "accent",
  },

  info: {
    dark: false,
    fg: "grey-10",
    bg: "info",
  },
  negative: {
    dark: true,
    fg: "grey-1",
    bg: "negative",
  },
  positive: {
    dark: true,
    fg: "grey-1",
    bg: "positive",
  },
  warning: {
    dark: false,
    fg: "grey-10",
    bg: "warning",
  },

  // Neutral status (pending work orders, referred/other service types).
  // Several service status maps declare `color: "grey"`; without this entry
  // they spread `undefined` fg/bg and render with no colour at all.
  grey: {
    dark: false,
    fg: "grey-10",
    bg: "grey-4",
  },

  empty: {
    dark: false,
    fg: "grey-6",
    bg: "grey-2",
  },
  emptyDark: {
    dark: true,
    fg: "grey-5",
    bg: "grey-9",
  },

  // Locations
  westerville: {
    dark: true,
    fg: "grey-1",
    bg: "green-8",
  },
  westervillewh: {
    dark: true,
    fg: "grey-1",
    bg: "green-8",
  },
  medina: {
    dark: false,
    fg: "grey-10",
    bg: "amber-5",
  },
  worthington: {
    dark: false,
    fg: "grey-1",
    bg: "green-8",
  },
  cincinnati: {
    dark: true,
    fg: "grey-1",
    bg: "red-7",
  },
  bonitasprings: {
    dark: true,
    fg: "grey-1",
    bg: "purple-7",
  },

  // Events
  personal: {
    dark: true,
    fg: "grey-1",
    bg: "blue-grey-6",
  },
  ooo: {
    dark: true,
    fg: "grey-1",
    bg: "red-10",
  },
  meeting: {
    dark: true,
    fg: "grey-1",
    bg: "deep-purple-6",
  },
  delivery: {
    dark: true,
    fg: "grey-1",
    bg: "blue-6",
  },
  pickup: {
    dark: false,
    fg: "grey-10",
    bg: "cyan-5",
  },
  installation: {
    dark: false,
    fg: "grey-10",
    bg: "teal-5",
  },
  service: {
    dark: false,
    fg: "grey-10",
    bg: "orange-5",
  },

  // Teams
  salesTeam: {
    dark: true,
    fg: "grey-1",
    bg: "purple",
  },

  // Wholesale account
  wholesale: {
    dark: false,
    fg: "grey-10",
    bg: "amber-4",
  },

  "": {
    dark: undefined,
    fg: "",
    bg: "",
  },
};
deepFreeze(COLORS);

export default COLORS;
